const userProfileData = {
  horoscope: ["South Indian", "North Indian", "East Indian", "Kerala", "Srilankan"],
  horoscopeStyle: ["South Indian", "North Indian", "East Indian", "Kerala", "Srilankan"],
  gender: ["Male", "Female"],
  validChars: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "Backspace", "ArrowLeft", "ArrowRight", "Delete"],
};

export default userProfileData;
